/**
 * @file
 * Custom JS behaviour for History.
 */

(function ($) {

  Drupal.behaviors.timeline = {
    attach: function (context, settings) {

      var $body = $('body');

      if ($body.hasClass('node-7') && !$body.hasClass('timeline')) {

        if (window.matchMedia("(min-width: 1025px)").matches) {
          var $height_container = $('.view-stories-timeline.view-display-id-block_2 .view-content').height();

          //$('#block-views-block-stories-timeline-block-1').height($height_container * 2);
          // Pin images section
          ScrollTrigger.create({
            trigger: ".region-after-content",
            start: "top 0%",
            end: "bottom 100%",
            pin: "#block-views-block-stories-timeline-block-1",
            pinSpacing: false,
            markers: false
          });

          var $titleYears = $('.title-year');

          // Default.
          //$titleYears.eq(0).addClass('active');
          $('.card').eq(0).addClass('active');

          $titleYears.each(function () {

            var target = $(this).attr('data-target');
            var $card = $('.card.' + target);

            var activeCardImage = function () {
              $('.card').removeClass('active');
              $card.addClass('active');
            }

            var deactiveCardImage = function () {
              $card.removeClass('active');

              // Events
              $(document).on('mousewheel DOMMouseScroll', "element", function (e) {
                let delta = e.originalEvent.wheelDelta;

                if (delta > 0 || e.originalEvent.detail < 0) {

                }
                if (delta < 0 || e.originalEvent.detail > 0) {
                  //donwScrollFunction();
                  console.log('down')
                  if (!$('.card.active').length > 0) {
                    $('.card').eq(0).addClass('active');
                  }
                }
              });

            }

            ScrollTrigger.create({
              trigger: $(this),
              start: "top 20%",
              end: "bottom 20%",
              markers: false,
              toggleClass: 'active',
              onEnter: activeCardImage,
              onEnterBack: activeCardImage,
              onLeave: deactiveCardImage,
              onLeaveBack: deactiveCardImage
            });

          });

        }

        $body.addClass('timeline');
      }

    }
  };

})(jQuery);
